module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Louisa Edwards\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Louisa Edwards")]), _vm._v(" is the author of "), _c('I', [_vm._v("Can't Stand the Heat")]), _vm._v(" and"), _c('I', [_vm._v(" Just One Taste")]), _vm._v(". She grew up in Virginia, where at the age of 11, she was already sneaking Harlequin romances from her grandmother's suitcase, much to her parents' horror. She graduated from Bryn Mawr College before moving to Manhattan to work in book publishing—a dream job that allowed her to earn a living by reading romance novels. She later moved to Ohio, where she worked as a restaurant reviewer. The Recipe for Love series combines her love of food and romance. When she's not writing, Louisa eats at as many wonderful restaurants as possible—purely for research, of course.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17ZlCfp/tc-custom/9781429939003.jpg?1731166618698",
      "alt": "This image is the cover for the book On the Steamy Side, Recipe for Love"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("On the Steamy Side, Recipe for Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Lilah Jane Tunkle fled her dull life in Virginia for the bright lights of New York City, she didn't expect to wind up a nanny to a gorgeous celebrity chef's ten-year-old son. Working for the delectable Devon Sparks is a sure-fire recipe for disaster, especially after Lilah gets a tantalizing taste of his perfectly seasoned kisses …"), _c('br'), _c('br'), _vm._v("Devon's not sure he can handle one more surprise ingredient in his life—he quit his popular TV show, his culinary reputation is on the line, and now the son he barely knows is back for seconds. Lilah's Southern sass is supposed to keep the boy in line, but soon enough she's teaching Devon a thing or two about homespun food…and turning up the heat.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0